package com.cybersoftsolution.cybersoftsolutionweb.api

import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Config
import com.cybersoftsolution.cybersoftsolutionweb.models.ConfigResponse
import com.cybersoftsolution.cybersoftsolutionweb.models.DeleteRequest
import com.cybersoftsolution.cybersoftsolutionweb.models.Page
import com.cybersoftsolution.cybersoftsolutionweb.models.Post
import com.cybersoftsolution.cybersoftsolutionweb.models.SimplePost
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.CONFIG_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.UPSERT_POST_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.DELETE_POSTS_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.GET_POST_BY_ID_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.GET_SERVER_CONFIG_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.GET_SIMPLE_POSTS_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.IS_PRODUCTION_MODE_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.SET_SERVER_CONFIG_ROUTE
import com.cybersoftsolution.futures.base.models.Response
import com.varabyte.kobweb.browser.api
import kotlinx.browser.window
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json


suspend fun isProductionMode(): Response<Boolean>? {

    return try {
        val request = window.api.tryGet(
            apiPath = CONFIG_ROUTE + IS_PRODUCTION_MODE_ROUTE,
        )

        request?.let {
            Json.decodeFromString<Response<Boolean>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("isProductionMode Error: ${e.message}")
        null
    }

}

suspend fun getServerConfig(): ConfigResponse? {

    return try {
        val request = window.api.tryGet(
            apiPath = CONFIG_ROUTE + GET_SERVER_CONFIG_ROUTE,
        )

        request?.let {
            Json.decodeFromString<ConfigResponse?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("getServerConfig Error: ${e.message}")
        null
    }

}

suspend fun setServerConfig(config:Config): ConfigResponse? {

    return try {
        val request = window.api.tryPost(
            apiPath = CONFIG_ROUTE + SET_SERVER_CONFIG_ROUTE,
        body = Json.encodeToString(
            config
        ).encodeToByteArray()
        )

        request?.let {
        Json.decodeFromString<ConfigResponse?>(it.decodeToString() )
        }

    } catch (e: Exception) {
    console.error("setServerConfig Error: ${e.message}")
    null
    }


}


